import Vue from 'vue'
import * as types from '../mutation-types'

// initial state
const state = {
  contentsHome: {},
  contentsAnalytics: {}
}

// getters
const getters = {
  contentsHome: state => state.contentsHome,
  contentsAnalytics: state => state.contentsAnalytics
}

// actions
const actions = {
  getContentsHome ({ state, commit }, args) {
    return Vue.axios.get('contents/home/', {
      headers: args.headers
    }).then((response) => {
      commit(types.RECEIVE_CONTENTS_HOME, { response })
    })
  },
  getContentsAnalytics ({ state, commit }, args) {
    return Vue.axios.get('contents/analytics/', {
      headers: args.headers
    }).then((response) => {
      commit(types.RECEIVE_CONTENTS_ANALYTICS, { response })
    })
  }
}

// mutations
const mutations = {
  [types.RECEIVE_CONTENTS_HOME] (state, { response }) {
    state.contentsHome = response.data.results
  },
  [types.RECEIVE_CONTENTS_ANALYTICS] (state, { response }) {
    state.contentsAnalytics = response.data.results
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
